module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pySNsW/tc-custom/9781614751205.jpg?1721404571024",
      "alt": "This image is the cover for the book Ocean"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ocean\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("From a "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author, an ecological thriller about human animal hybrids battling to rescue the ocean from environmental impact. ")])]), _c('p', [_vm._v(" In 2024, Earth is consumed by a great War of Ocean Liberation: a military force of sea creatures attacks naval installations, shuts down shipping lanes and fishing operations, and destroys offshore oil-drilling rigs. Huge blue whales, sharks, dolphins, and even monstrous creatures thought to be extinct—all strike with ferocity and surprising strength. ")]), _c('p', [_vm._v(" The marine armada is led by hybrid, transformed humans who call themselves Sea Warriors, ocean-rights zealots who can swim to the deepest regions of the sea and live off the bounty of the waters. Their commander, Kimo Pohaku, announces his startling intention: The complete liberation of the seas from human control. ")]), _c('p', [_vm._v(" Finally, the ocean is fighting back, but it might be too late . . . ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brian Herbert, Jan Herbert\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Word Fire Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0